export const incorporationState = [
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'District of Columbia', label: 'District of Columbia' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' }
];

export const planRule= [
    { value: 'EndOfPriorMonth', label: 'End of Prior Month' },
    { value: 'DateOfQualifyingEvent', label: 'Event Date' },
    { value: 'EndOfMonth', label: 'End of the month' },
    { value: 'RollRoll', label: 'RollRoll' },
    { value: 'WashRoll', label: 'WashRoll' }
];

export const planRateType= [
    { value: 'Composite', label: 'Composite' },
    { value: 'Age/Banded', label: 'Age/Gender' },
    { value: 'MemberSpecific', label: 'Member Specific' },
    { value: 'UnitBased', label: 'Unit Based' },
    { value: 'Unit + Age/Gender', label: 'Unit + Age/Gender' }
];

export const insuranceType = [
    { value: 'Fully Insured', label: 'Fully Insured' },
    { value: 'Self Insured', label: 'Self Insured' }
  ];

export const carrierOptions = [
    { value: '1800 MD', label: '1800 MD' },
    { value: '90 Degree Benefits', label: '90 Degree Benefits' },
    { value: 'AblePay', label: 'AblePay' },
    { value: 'Accountable Care Management Group (ACMG)', label: 'Accountable Care Management Group (ACMG)' },
    { value: 'Advantage Administrators', label: 'Advantage Administrators' },
    { value: 'Advantica', label: 'Advantica' },
    { value: 'Aegis General', label: 'Aegis General' },
    { value: 'Aetna', label: 'Aetna' },
    { value: 'Aetna AFA', label: 'Aetna AFA' },
    { value: 'Aetna Global', label: 'Aetna Global' },
    { value: 'Aflac', label: 'Aflac' },
    { value: 'Aircraft Precision Products Inc', label: 'Aircraft Precision Products Inc' },
    { value: 'Aither', label: 'Aither' },
    { value: 'Alerus', label: 'Alerus' },
    { value: 'All Savers', label: 'All Savers' },
    { value: 'Alliance Work Partners', label: 'Alliance Work Partners' },
    { value: 'Allied', label: 'Allied' },
    { value: 'Allina Health Aetna', label: 'Allina Health Aetna' },
    { value: 'AllOne Health', label: 'AllOne Health' },
    { value: 'Allstate', label: 'Allstate' },
    { value: 'Allura Health', label: 'Allura Health' },
    { value: 'AllWays Health Care', label: 'AllWays Health Care' },
    { value: 'Ally Health', label: 'Ally Health' },
    { value: 'AlwaysCare Benefits', label: 'AlwaysCare Benefits' },
    { value: 'American Benefits Group', label: 'American Benefits Group' },
    { value: 'American Fidelity', label: 'American Fidelity' },
    { value: 'American Public Life', label: 'American Public Life' },
    { value: 'Ameriflex', label: 'Ameriflex' },
    { value: 'AmeriHealth', label: 'AmeriHealth' },
    { value: 'Ameritas', label: 'Ameritas' },
    { value: 'AmFirst', label: 'AmFirst' },
    { value: 'AmWins', label: 'AmWins' },
    { value: 'Anchor Benefit Consulting', label: 'Anchor Benefit Consulting' },
    { value: 'Angel Health', label: 'Angel Health' },
    { value: 'Angle Health', label: 'Angle Health' },
    { value: 'Anthem', label: 'Anthem' },
    { value: 'Apex Management Grp', label: 'Apex Management Grp' },
    { value: 'APL', label: 'APL' },
    { value: 'Argus', label: 'Argus' },
    { value: 'ASCI Specialty Benefits', label: 'ASCI Specialty Benefits' },
    { value: 'Associated Employers Group Benefit & Trust', label: 'Associated Employers Group Benefit & Trust' },
    { value: 'Assurant', label: 'Assurant' },
    { value: 'Assured Benefits Administrators', label: 'Assured Benefits Administrators' },
    { value: 'Aultcare Insurance Company', label: 'Aultcare Insurance Company' },
    { value: 'Auxiant', label: 'Auxiant' },
    { value: 'Avesis', label: 'Avesis' },
    { value: 'Avidia Bank', label: 'Avidia Bank' },
    { value: 'Avmed', label: 'Avmed' },
    { value: 'AvMen', label: 'AvMen' },
    { value: 'BABBmrp', label: 'BABBmrp' },
    { value: 'BAC', label: 'BAC' },
    { value: 'Bank of America', label: 'Bank of America' },
    { value: 'Banner Aetna', label: 'Banner Aetna' },
    { value: 'Barkley Risk Management & Insurance', label: 'Barkley Risk Management & Insurance' },
    { value: 'BASIC', label: 'BASIC' },
    { value: 'Bay Bridge Administrators', label: 'Bay Bridge Administrators' },
    { value: 'BBP Admin', label: 'BBP Admin' },
    { value: 'BCBS', label: 'BCBS' },
    { value: 'Beacon Health Options', label: 'Beacon Health Options' },
    { value: 'Beam', label: 'Beam' },
    { value: 'Beam Dental', label: 'Beam Dental' },
    { value: 'Benefit Coordinators', label: 'Benefit Coordinators' },
    { value: 'Benefit Extras', label: 'Benefit Extras' },
    { value: 'Benefit Management Administrators', label: 'Benefit Management Administrators' },
    { value: 'Benefit Resource', label: 'Benefit Resource' },
    { value: 'Benefit Strategies', label: 'Benefit Strategies' },
    { value: 'BenefitMall', label: 'BenefitMall' },
    { value: 'BenefitWallet', label: 'BenefitWallet' },
    { value: 'Beneflex Management', label: 'Beneflex Management' },
    { value: 'Best Life and Health Insurance company', label: 'Best Life and Health Insurance company' },
    { value: 'BHS', label: 'BHS' },
    { value: 'Blue Care Network', label: 'Blue Care Network' },
    { value: 'Blue Cross', label: 'Blue Cross' },
    { value: 'Blue Cross Blue Shield', label: 'Blue Cross Blue Shield' },
    { value: 'Blue of California', label: 'Blue of California' },
    { value: 'Blue Shield', label: 'Blue Shield' },
    { value: 'BPC Inc.', label: 'BPC Inc.' },
    { value: 'Breckpoint', label: 'Breckpoint' },
    { value: 'BRI', label: 'BRI' },
    { value: 'Bright Benefits', label: 'Bright Benefits' },
    { value: 'Buoy', label: 'Buoy' },
    { value: 'Bywater', label: 'Bywater' },
    { value: 'CalChoice', label: 'CalChoice' },
    { value: 'California Blue', label: 'California Blue' },
    { value: 'California Dental', label: 'California Dental' },
    { value: 'California Physicians Services', label: 'California Physicians Services' },
    { value: 'Canopy Insurance', label: 'Canopy Insurance' },
    { value: 'Capital Blue Cross', label: 'Capital Blue Cross' },
    { value: 'Capital District Physician\'s Health Plan', label: 'Capital District Physician\'s Health Plan' },
    { value: 'Capital Health Plan', label: 'Capital Health Plan' },
    { value: 'Carebridge Corporation', label: 'Carebridge Corporation' },
    { value: 'CareFirst', label: 'CareFirst' },
    { value: 'CareFlex', label: 'CareFlex' },
    { value: 'Caresource', label: 'Caresource' },
    { value: 'Carpenters', label: 'Carpenters' },
    { value: 'Cascade Centers Inc', label: 'Cascade Centers Inc' },
    { value: 'Catilize Health', label: 'Catilize Health' },
    { value: 'CBIZ', label: 'CBIZ' },
    { value: 'CDPHP', label: 'CDPHP' },
    { value: 'Centivo', label: 'Centivo' },
    { value: 'Chard Snyder', label: 'Chard Snyder' },
    { value: 'Choice Builder', label: 'Choice Builder' },
    { value: 'Chubb', label: 'Chubb' },
    { value: 'Cigna', label: 'Cigna' },
    { value: 'CIGNA Global', label: 'CIGNA Global' },
    { value: 'Cigna Healthcare', label: 'Cigna Healthcare' },
    { value: 'Clarity Benefit Solutions', label: 'Clarity Benefit Solutions' },
    { value: 'ClearShare', label: 'ClearShare' },
    { value: 'Colonial Life', label: 'Colonial Life' },
    { value: 'Community Eye Care', label: 'Community Eye Care' },
    { value: 'CommunityCare', label: 'CommunityCare' },
    { value: 'Companion Life', label: 'Companion Life' },
    { value: 'CompPsych', label: 'CompPsych' },
    { value: 'Concern', label: 'Concern' },
    { value: 'Connecticare', label: 'Connecticare' },
    { value: 'CoPower', label: 'CoPower' },
    { value: 'Corporate Counseling Associates (CCA)', label: 'Corporate Counseling Associates (CCA)' },
    { value: 'Costco Health Solutions', label: 'Costco Health Solutions' },
    { value: 'Covered', label: 'Covered' },
    { value: 'Covered California', label: 'Covered California' },
    { value: 'Cox Health Plan', label: 'Cox Health Plan' },
    { value: 'CuraLinc Healthcare', label: 'CuraLinc Healthcare' },
    { value: 'Curative', label: 'Curative' },
    { value: 'Custom Design Benefits', label: 'Custom Design Benefits' },
    { value: 'CVS Health', label: 'CVS Health' },
    { value: 'Cypress', label: 'Cypress' },
    { value: 'Dacadoo', label: 'Dacadoo' },
    { value: 'Davis Vision', label: 'Davis Vision' },
    { value: 'Dean Health Plan', label: 'Dean Health Plan' },
    { value: 'Dearborn National', label: 'Dearborn National' },
    { value: 'Delta', label: 'Delta' },
    { value: 'Delta Care', label: 'Delta Care' },
    { value: 'Delta Dental', label: 'Delta Dental' },
    { value: 'Delta Vision', label: 'Delta Vision' },
    { value: 'Denali Dental', label: 'Denali Dental' },
    { value: 'Dental Care Plus Group', label: 'Dental Care Plus Group' },
    { value: 'Dental Essentials', label: 'Dental Essentials' },
    { value: 'Dental Health', label: 'Dental Health' },
    { value: 'Dental Select', label: 'Dental Select' },
    { value: 'Direct Dental Administrators', label: 'Direct Dental Administrators' },
    { value: 'Discovery Benefits', label: 'Discovery Benefits' },
    { value: 'Dominion', label: 'Dominion' },
    { value: 'DP Complete Care', label: 'DP Complete Care' },
    { value: 'E.D.I.S.', label: 'E.D.I.S.' },
    { value: 'EBA&M', label: 'EBA&M' },
    { value: 'EBC Corp', label: 'EBC Corp' },
    { value: 'EDIS', label: 'EDIS' },
    { value: 'Edison Health', label: 'Edison Health' },
    { value: 'EE Owned Holdings', label: 'EE Owned Holdings' },
    { value: 'eHealth Vision', label: 'eHealth Vision' },
    { value: 'EHiM', label: 'EHiM' },
    { value: 'Emblem Health', label: 'Emblem Health' },
    { value: 'EMI Health', label: 'EMI Health' },
    { value: 'Empire Blue Cross', label: 'Empire Blue Cross' },
    { value: 'Empire Blue Cross Blue Shield', label: 'Empire Blue Cross Blue Shield' },
    { value: 'Empire HealthChoice HMO Inc', label: 'Empire HealthChoice HMO Inc' },
    { value: 'Employee Benefit Systems Inc.', label: 'Employee Benefit Systems Inc.' },
    { value: 'Employee Benefits Consultants', label: 'Employee Benefits Consultants' },
    { value: 'Employee Benefits Corporation', label: 'Employee Benefits Corporation' },
    { value: 'Employer Driven Insurance Services', label: 'Employer Driven Insurance Services' },
    { value: 'Employers Dental Service (EDS)', label: 'Employers Dental Service (EDS)' },
    { value: 'Equitable', label: 'Equitable' },
    { value: 'ESI Inc.', label: 'ESI Inc.' },
    { value: 'Evolution Healthcare', label: 'Evolution Healthcare' },
    { value: 'Excel Health', label: 'Excel Health' },
    { value: 'Excellus', label: 'Excellus' },
    { value: 'Excellus BCBS', label: 'Excellus BCBS' },
    { value: 'Express Scripts', label: 'Express Scripts' },
    { value: 'EyeMed', label: 'EyeMed' },
    { value: 'Fidelity Investments', label: 'Fidelity Investments' },
    { value: 'Fidility Security Life', label: 'Fidility Security Life' },
    { value: 'Fifth Third', label: 'Fifth Third' },
    { value: 'First Choice Health', label: 'First Choice Health' },
    { value: 'First Continental', label: 'First Continental' },
    { value: 'FitLyfe', label: 'FitLyfe' },
    { value: 'FlexFacts', label: 'FlexFacts' },
    { value: 'Flexible Benefit Administrators', label: 'Flexible Benefit Administrators' },
    { value: 'Flores', label: 'Flores' },
    { value: 'Florida Blue', label: 'Florida Blue' },
    { value: 'Florida Combined Life', label: 'Florida Combined Life' },
    { value: 'Florida Health Solution', label: 'Florida Health Solution' },
    { value: 'Flyte HCM', label: 'Flyte HCM' },
    { value: 'Fountain Health', label: 'Fountain Health' },
    { value: 'Freedom Health', label: 'Freedom Health' },
    { value: 'Fringe Benefit Group', label: 'Fringe Benefit Group' },
    { value: 'FSA Health Care', label: 'FSA Health Care' },
    { value: 'Further', label: 'Further' },
    { value: 'Garner', label: 'Garner' },
    { value: 'Geisinger', label: 'Geisinger' },
    { value: 'Gettysburg Benefits Administrators', label: 'Gettysburg Benefits Administrators' },
    { value: 'Gilsbar', label: 'Gilsbar' },
    { value: 'GL Group FSA', label: 'GL Group FSA' },
    { value: 'Gravie', label: 'Gravie' },
    { value: 'Group Dental Service', label: 'Group Dental Service' },
    { value: 'Group Health Cooperative', label: 'Group Health Cooperative' },
    { value: 'Group Health Inc', label: 'Group Health Inc' },
    { value: 'Group Health Plan', label: 'Group Health Plan' },
    { value: 'Group Vision Services', label: 'Group Vision Services' },
    { value: 'Guardian', label: 'Guardian' },
    { value: 'Guidewill Mut Holding', label: 'Guidewill Mut Holding' },
    { value: 'Harrison Group', label: 'Harrison Group' },
    { value: 'Hartford Life Insurance Co', label: 'Hartford Life Insurance Co' },
    { value: 'Harvard Pilgrim Health Care', label: 'Harvard Pilgrim Health Care' },
    { value: 'Hawaii Medical Assurance Association', label: 'Hawaii Medical Assurance Association' },
    { value: 'HBA', label: 'HBA' },
    { value: 'Healics', label: 'Healics' },
    { value: 'Health Alliance', label: 'Health Alliance' },
    { value: 'Health Benefit Alliance', label: 'Health Benefit Alliance' },
    { value: 'Health Care Services Corporation', label: 'Health Care Services Corporation' },
    { value: 'Health Hero Inc', label: 'Health Hero Inc' },
    { value: 'Health Management Systems of America', label: 'Health Management Systems of America' },
    { value: 'Health New England', label: 'Health New England' },
    { value: 'Health Partners', label: 'Health Partners' },
    { value: 'Health Plans Inc.', label: 'Health Plans Inc.' },
    { value: 'HealthAdvocate', label: 'HealthAdvocate' },
    { value: 'HealthEquity', label: 'HealthEquity' },
    { value: 'HealthEz', label: 'HealthEz' },
    { value: 'HealthFirst', label: 'HealthFirst' },
    { value: 'Healthgram', label: 'Healthgram' },
    { value: 'Healthiest You', label: 'Healthiest You' },
    { value: 'Healthnet', label: 'Healthnet' },
    { value: 'HealthPass', label: 'HealthPass' },
    { value: 'HealthSavings Administrators', label: 'HealthSavings Administrators' },
    { value: 'Healthy Dollars', label: 'Healthy Dollars' },
    { value: 'Highmark', label: 'Highmark' },
    { value: 'HIP Health Maintenance Organization', label: 'HIP Health Maintenance Organization' },
    { value: 'HMC HealthWorks', label: 'HMC HealthWorks' },
    { value: 'HNAS - Healthnow Services', label: 'HNAS - Healthnow Services' },
    { value: 'Horizon', label: 'Horizon' },
    { value: 'Humana', label: 'Humana' },
    { value: 'IBH Worklife', label: 'IBH Worklife' },
    { value: 'IBX', label: 'IBX' },
    { value: 'IDA', label: 'IDA' },
    { value: 'Igoe & Company', label: 'Igoe & Company' },
    { value: 'IHP', label: 'IHP' },
    { value: 'Imagine 360', label: 'Imagine 360' },
    { value: 'Independence Administrators', label: 'Independence Administrators' },
    { value: 'Independence Blue Cross', label: 'Independence Blue Cross' },
    { value: 'Independence Health Group Inc', label: 'Independence Health Group Inc' },
    { value: 'Independent Health Association', label: 'Independent Health Association' },
    { value: 'INFINISOURCE FSA', label: 'INFINISOURCE FSA' },
    { value: 'In-house', label: 'In-house' },
    { value: 'Innovative Health Plan', label: 'Innovative Health Plan' },
    { value: 'Inshore', label: 'Inshore' },
    { value: 'Inspira Financial', label: 'Inspira Financial' },
    { value: 'iSolved', label: 'iSolved' },
    { value: 'Journey Meditation', label: 'Journey Meditation' },
    { value: 'Kaiser', label: 'Kaiser' },
    { value: 'Kaiser Foundation', label: 'Kaiser Foundation' },
    { value: 'Kaiser Permanente', label: 'Kaiser Permanente' },
    { value: 'Kansas City Life', label: 'Kansas City Life' },
    { value: 'Kavira Health', label: 'Kavira Health' },
    { value: 'Kempton', label: 'Kempton' },
    { value: 'Key Benefit Administrators', label: 'Key Benefit Administrators' },
    { value: 'Keystone Health', label: 'Keystone Health' },
    { value: 'Landmark', label: 'Landmark' },
    { value: 'Lane Health', label: 'Lane Health' },
    { value: 'Lasallian', label: 'Lasallian' },
    { value: 'Leading Edge Administrators', label: 'Leading Edge Administrators' },
    { value: 'Liberty', label: 'Liberty' },
    { value: 'Life XT', label: 'Life XT' },
    { value: 'Lifetime Benefit Solutions', label: 'Lifetime Benefit Solutions' },
    { value: 'LifeWorks', label: 'LifeWorks' },
    { value: 'Lincoln Financial', label: 'Lincoln Financial' },
    { value: 'Lincoln Financial Group', label: 'Lincoln Financial Group' },
    { value: 'Lively', label: 'Lively' },
    { value: 'Lucent Health', label: 'Lucent Health' },
    { value: 'Luminare', label: 'Luminare' },
    { value: 'Lyra Health', label: 'Lyra Health' },
    { value: 'Magellan Health', label: 'Magellan Health' },
    { value: 'Makina', label: 'Makina' },
    { value: 'Marpai Health', label: 'Marpai Health' },
    { value: 'Marquee Health', label: 'Marquee Health' },
    { value: 'MASA', label: 'MASA' },
    { value: 'MCNA Insurance Co.', label: 'MCNA Insurance Co.' },
    { value: 'Medica', label: 'Medica' },
    { value: 'Medical Mutual', label: 'Medical Mutual' },
    { value: 'MediCharge', label: 'MediCharge' },
    { value: 'Mediexcel', label: 'Mediexcel' },
    { value: 'Medsurety', label: 'Medsurety' },
    { value: 'Memorial Hermann Health Insurance Company', label: 'Memorial Hermann Health Insurance Company' },
    { value: 'Mertain Health', label: 'Mertain Health' },
    { value: 'MES Vision', label: 'MES Vision' },
    { value: 'MetLife', label: 'MetLife' },
    { value: 'Metropolitan', label: 'Metropolitan' },
    { value: 'Michigan Manufacturer\'s Association', label: 'Michigan Manufacturer\'s Association' },
    { value: 'Moda Health', label: 'Moda Health' },
    { value: 'Molina Healthcare', label: 'Molina Healthcare' },
    { value: 'Multimedical System', label: 'Multimedical System' },
    { value: 'Municipal Health Solutions (MHS)', label: 'Municipal Health Solutions (MHS)' },
    { value: 'Mutual of Omaha', label: 'Mutual of Omaha' },
    { value: 'MVP Medical', label: 'MVP Medical' },
    { value: 'My Benefit Wallet', label: 'My Benefit Wallet' },
    { value: 'National Vision Administrators - NVA', label: 'National Vision Administrators - NVA' },
    { value: 'Navia Benefit Solutions', label: 'Navia Benefit Solutions' },
    { value: 'Neighborhood Health Partnership', label: 'Neighborhood Health Partnership' },
    { value: 'New Benefits', label: 'New Benefits' },
    { value: 'Next Level', label: 'Next Level' },
    { value: 'NICE', label: 'NICE' },
    { value: 'Nippon', label: 'Nippon' },
    { value: 'Nippon Life Benefits', label: 'Nippon Life Benefits' },
    { value: 'Non Stop Health', label: 'Non Stop Health' },
    { value: 'Northeast Benefit Management', label: 'Northeast Benefit Management' },
    { value: 'Northeast Delta Dental', label: 'Northeast Delta Dental' },
    { value: 'NRI', label: 'NRI' },
    { value: 'OCA Benefit Services', label: 'OCA Benefit Services' },
    { value: 'One Stop Wellness Inc', label: 'One Stop Wellness Inc' },
    { value: 'OneSource', label: 'OneSource' },
    { value: 'Optima', label: 'Optima' },
    { value: 'Options Plus', label: 'Options Plus' },
    { value: 'Optum', label: 'Optum' },
    { value: 'Orriant', label: 'Orriant' },
    { value: 'OSMA Health', label: 'OSMA Health' },
    { value: 'Other (list carrier name as part of plan name)', label: 'Other (list carrier name as part of plan name)' },
    { value: 'Oxford', label: 'Oxford' },
    { value: 'PacifiCare Health Systems', label: 'PacifiCare Health Systems' },
    { value: 'PacificSource', label: 'PacificSource' },
    { value: 'Pacify', label: 'Pacify' },
    { value: 'Paramount Dental', label: 'Paramount Dental' },
    { value: 'PATHIAN', label: 'PATHIAN' },
    { value: 'Pathian VSP', label: 'Pathian VSP' },
    { value: 'Personal Choice', label: 'Personal Choice' },
    { value: 'Perspectives LTD', label: 'Perspectives LTD' },
    { value: 'PHCS/Humana', label: 'PHCS/Humana' },
    { value: 'PHP Freedom', label: 'PHP Freedom' },
    { value: 'PHP TPA Services', label: 'PHP TPA Services' },
    { value: 'Physicians Health Plan', label: 'Physicians Health Plan' },
    { value: 'Physicians Mutual', label: 'Physicians Mutual' },
    { value: 'PNC Bank', label: 'PNC Bank' },
    { value: 'PreferredOne', label: 'PreferredOne' },
    { value: 'Premera', label: 'Premera' },
    { value: 'Premera Blue Cross', label: 'Premera Blue Cross' },
    { value: 'Premier Access', label: 'Premier Access' },
    { value: 'Premise Health', label: 'Premise Health' },
    { value: 'PrimeFlex', label: 'PrimeFlex' },
    { value: 'PrimePay', label: 'PrimePay' },
    { value: 'Principal', label: 'Principal' },
    { value: 'Principal Dental', label: 'Principal Dental' },
    { value: 'Principal Financial Group', label: 'Principal Financial Group' },
    { value: 'Principal Life', label: 'Principal Life' },
    { value: 'Priority Health', label: 'Priority Health' },
    { value: 'Private Healthcare Systems', label: 'Private Healthcare Systems' },
    { value: 'Prosperity', label: 'Prosperity' },
    { value: 'Providence Health Plan', label: 'Providence Health Plan' },
    { value: 'Quartz Benefits', label: 'Quartz Benefits' },
    { value: 'Redirect Health', label: 'Redirect Health' },
    { value: 'Redwood Health Services', label: 'Redwood Health Services' },
    { value: 'Regence', label: 'Regence' },
    { value: 'Reliance Matrix', label: 'Reliance Matrix' },
    { value: 'Reliance Standard', label: 'Reliance Standard' },
    { value: 'Renaissance', label: 'Renaissance' },
    { value: 'Revive Health', label: 'Revive Health' },
    { value: 'Roundstone', label: 'Roundstone' },
    { value: 'S&S Health', label: 'S&S Health' },
    { value: 'Sana', label: 'Sana' },
    { value: 'Sanford Health Plan', label: 'Sanford Health Plan' },
    { value: 'SBMA', label: 'SBMA' },
    { value: 'Security Fire', label: 'Security Fire' },
    { value: 'Security Health Plan', label: 'Security Health Plan' },
    { value: 'Select Health', label: 'Select Health' },
    { value: 'Sentara Health', label: 'Sentara Health' },
    { value: 'Sharp Health Plan', label: 'Sharp Health Plan' },
    { value: 'Sidecar Health', label: 'Sidecar Health' },
    { value: 'Sierra Health and Life', label: 'Sierra Health and Life' },
    { value: 'SIHO', label: 'SIHO' },
    { value: 'SIMNSA', label: 'SIMNSA' },
    { value: 'Simply Healthcare Plans Inc', label: 'Simply Healthcare Plans Inc' },
    { value: 'SMBA', label: 'SMBA' },
    { value: 'SmileSaver', label: 'SmileSaver' },
    { value: 'Solstice', label: 'Solstice' },
    { value: 'Spirit Dental', label: 'Spirit Dental' },
    { value: 'Spring Health', label: 'Spring Health' },
    { value: 'Standard (Ameritas)', label: 'Standard (Ameritas)' },
    { value: 'Standard Insurance Company', label: 'Standard Insurance Company' },
    { value: 'Sterling Administration', label: 'Sterling Administration' },
    { value: 'StreamlineHR', label: 'StreamlineHR' },
    { value: 'SunLife', label: 'SunLife' },
    { value: 'Superior Dental', label: 'Superior Dental' },
    { value: 'Superior USA Benefits', label: 'Superior USA Benefits' },
    { value: 'Superior Vision', label: 'Superior Vision' },
    { value: 'Support Linc', label: 'Support Linc' },
    { value: 'Surency', label: 'Surency' },
    { value: 'Surest Health Plans (UnitedHealth Group)', label: 'Surest Health Plans (UnitedHealth Group)' },
    { value: 'Surrency', label: 'Surrency' },
    { value: 'Sutter Health', label: 'Sutter Health' },
    { value: 'SwiftMD', label: 'SwiftMD' },
    { value: 'Take Command', label: 'Take Command' },
    { value: 'TakeCare', label: 'TakeCare' },
    { value: 'TASC', label: 'TASC' },
    { value: 'TDA/EMI Health', label: 'TDA/EMI Health' },
    { value: 'TeleDoc', label: 'TeleDoc' },
    { value: 'TeleHealth', label: 'TeleHealth' },
    { value: 'Telus', label: 'Telus' },
    { value: 'The Advantage Group', label: 'The Advantage Group' },
    { value: 'The American Worker- Fringe Benefit Group', label: 'The American Worker- Fringe Benefit Group' },
    { value: 'The Difference Card', label: 'The Difference Card' },
    { value: 'The Harrison Group', label: 'The Harrison Group' },
    { value: 'The HSA Authority', label: 'The HSA Authority' },
    { value: 'The Standard', label: 'The Standard' },
    { value: 'ThrivePass', label: 'ThrivePass' },
    { value: 'Tokio Marine', label: 'Tokio Marine' },
    { value: 'Total Dental Administrators', label: 'Total Dental Administrators' },
    { value: 'TPA Systems Inc.', label: 'TPA Systems Inc.' },
    { value: 'TransAmerica', label: 'TransAmerica' },
    { value: 'Trustmark', label: 'Trustmark' },
    { value: 'Tufts', label: 'Tufts' },
    { value: 'Tufts Health Plan', label: 'Tufts Health Plan' },
    { value: 'UCCI', label: 'UCCI' },
    { value: 'UHC', label: 'UHC' },
    { value: 'Ulliance', label: 'Ulliance' },
    { value: 'UMB Bank', label: 'UMB Bank' },
    { value: 'UMPC', label: 'UMPC' },
    { value: 'UMR', label: 'UMR' },
    { value: 'Unified Group Services', label: 'Unified Group Services' },
    { value: 'United Concordia', label: 'United Concordia' },
    { value: 'United Health Insurance', label: 'United Health Insurance' },
    { value: 'United Healthcare (UHC)', label: 'United Healthcare (UHC)' },
    { value: 'Unity Health Plans', label: 'Unity Health Plans' },
    { value: 'Univera Healthcare', label: 'Univera Healthcare' },
    { value: 'Universal Fidelity Life Insurance Co', label: 'Universal Fidelity Life Insurance Co' },
    { value: 'UNUM', label: 'UNUM' },
    { value: 'UPMC', label: 'UPMC' },
    { value: 'USAble Life', label: 'USAble Life' },
    { value: 'VBA', label: 'VBA' },
    { value: 'Vision Benefits of America', label: 'Vision Benefits of America' },
    { value: 'Vision Service Plan', label: 'Vision Service Plan' },
    { value: 'Voya', label: 'Voya' },
    { value: 'VSP', label: 'VSP' },
    { value: 'WageWorks', label: 'WageWorks' },
    { value: 'wayForward', label: 'wayForward' },
    { value: 'WellCare', label: 'WellCare' },
    { value: 'Wellmark BCBS', label: 'Wellmark BCBS' },
    { value: 'WellNet', label: 'WellNet' },
    { value: 'WellSpark Health', label: 'WellSpark Health' },
    { value: 'Wellspring', label: 'Wellspring' },
    { value: 'Wellworks For You', label: 'Wellworks For You' },
    { value: 'Western Dental', label: 'Western Dental' },
    { value: 'Western Health Advantage', label: 'Western Health Advantage' },
    { value: 'WEX', label: 'WEX' },
    { value: 'Willamette Dental', label: 'Willamette Dental' },
    { value: 'Workplace Options', label: 'Workplace Options' },
    { value: 'Zion', label: 'Zion' }
];